import { useFormContext } from 'react-hook-form';

import { TextArea } from '@xemplo/text-area';

import * as S from '../payrun-approve-reject.styles';
import { FieldProps, RejectEarningLinesType } from '../payrun-approve-reject.types';

export const RejectDescription = (props: FieldProps) => {
  const { shouldValidate } = props;

  const { setValue } = useFormContext<RejectEarningLinesType>();

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setValue('description', e.target.value, { shouldValidate: shouldValidate });
  };
  return (
    <S.FormLabel>
      Description
      <TextArea
        name="description"
        placeholder="Please enter reason"
        aria-label="rejection reason"
        onChange={handleChange}
        stretch
        required
      />
    </S.FormLabel>
  );
};
